import React from "react";
import "./Gallery.css";

const Article = () => {
  return (
    <div>
      <div>
        <p id="Human-Practices">
          Scientific progress would never be of use for society if scientists
          did not investigate the needs of the communities, the impact and the
          possible applications of their research. A scientific project needs a 
          strong human practices work to become a useful and efficient innovation 
          that is integrated in the society
        </p>

        <h2 id="approach" className="mt-20">
          Our approach
        </h2>
        <hr className="dividergeneral mb-5" />
        <p>
          For our team, human practices were were important from the beginning. 
          We first focused on evaluating the severity of cadmium
          contamination and we verified that the available solutions are
          insufficient to tackle such an environmental and health issue. As
          our solution is a genetically modified probiotic, the next step was
          to better understand how to introduce our product in society by initiating
          discussions with the professionals in the industry and with medical and 
          pharmaceutical experts. There is still a lot of misunderstandings and 
          mistrust when it comes to GMOs and for our product to eventually
          succeed it is essential to have an open and trasparent exchange with
          the communities that would take it to protect themselves.
        </p>

        <h3 id="events-hp" className="mt-20 mb-5">
          Events and collaborations
        </h3>
        <p className="mb-2">
          We are excited to share that Team 48C has been actively engaged in
          various events aimed at fostering discussions about our project and 
          promoting collaboration for the improvement of synthetic biology. With
          a shared passion for synthetic biology, we have participated in
          insightful gatherings, workshops, and forums, where we have not only
          presented our project but also eagerly absorbed diverse perspectives
          and ideas from fellow participants. In addition to enriching our project, these
          interactions have also solidified our commitment to
          creating a positive impact on society through collective effort. We
          are enthusiastic about continuing our collaborative journey, working
          towards advocating a world where synthetic biology aligns with
          community interests and is comprehensible to all.
        </p>
        <p className="mb-5">The list of the events we participated in is:</p>
        <ul
          className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}
        >
          <li>BioEngineering day EPFL</li>
          <li>MAKE projects conference</li>
          <li>UNIL waste Collection at Vidy</li>
          <li>Open days-booth</li>
          <li>Gymnase visit</li>
          <li>MINTeressiert die Welt!</li>
          <li>BSGV (Biologie Synthétique par les Gymnases Vaudois)</li>
          <li>Münster European Meet-up</li>
          <li>Zurich Swiss Meet-up</li>
          <li>Heavy metals Meet-up</li>
        </ul>

        <p>
          Learn more about our events and collaboration on the
          <a href="../epfl/events"> Event page</a>.
        </p>

        <h3 id="sustainability" className="mt-20 mb-5">
          Sustainability
        </h3>
        <p className="mb-2">
          At the core of our endeavor, sustainability takes precedence as we
          address the critical issue of cadmium pollution. Our dedication to
          environmental well-being led us to collaborate with Michka Mélo, a
          sustainability coach from EPFL. From the project's inception this
          summer, we maintained a dialogue and held consultations with Michka
          Mélo, ensuring a thorough examination of the ecological implications.
        </p>
        <p className="mb-2">
        In our first conversation we discussed new sustainability models, and 
        chose to focus on the wedding cake model. According to this model, 
        a healthy economy can only exist within a healthy society, and a healthy 
        society only within a healthy biosphere
          <a href="#reference1">
            <sup>1</sup>
          </a>
          .
        </p>
        <img
          src="https://static.igem.wiki/teams/4888/wiki/humanpractices/weddingcake2.png"
          style={{ paddingTop: "30px" }}
          alt="wedding cake"
        />

        <div
          className="text-imageright"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div className="text-box">
            <p className="mb-2">
              With our project we aim to assure access to food and water without a resulting intoxication. 
              In addition to using the probiotic on humans, one
              additional application we considered is in fact to administer it
              to the affected fauna in the contaminated areas. Adapting it to
              different digestive systems is going to be a future challenge if
              we decide to persevere in that direction. Related to our project
              is also the conscience of the need for a more sustainable and
              natural agriculture. The use of phosphate fertilizers is one of
              the main causes of contamination of the soil and consequently the
              crops and vegetables grown there
              <a href="#reference2">
                <sup>2</sup>
              </a>
              . Our probiotic could avoid chronic intoxication due to the
              consumption of product thus contaminated, but a shift in the
              agricultural practices is needed to solve the problem at the
              source.
            </p>
          </div>
          <img
            src="https://static.igem.wiki/teams/4888/wiki/humanpractices/grains.jpg"
            className="tohide"
            style={{ paddingTop: "30px", width: "30%", height: "auto" }}
            alt="grains"
          />
        </div>

        <p className="mb-2">
        While our solution relieves the communities from the consequences of cadmium pollution, 
        we are also acutely aware that a holistic approach is essential to permanently solve the 
        issue. Our project is an intermediate step to protect humans from cadmium while we 
        simultaneously purify the environment from it, which will unfortunately take decades. 
        Our solution is complementary to existing and future solutions aimed at eradicating the 
        very origins of this problem. It does not replace filters and other technologies aimed at 
        reducing the emission and purifying the environment, but rather supports them by giving 
        them more time by defending the communities that are now most affected by chronic exposure.
        </p>
        <p className="mb-2">
          For this reason, it is a policy of our group to only work with
          industries and companies on the condition that our probiotic is only
          one measure between others, an additional protection for their workers
          and the communities. But the necessity to reduce the exposure and pollution 
          must be addressed also by solutions that tackle the causes. When we started 
          the project, we had a fear of producing a "green-washing" product and we 
          discussed it internally and with Mr. Mèlo. Green-washing is pretending to 
          care instead of really taking measures for the environment, so our solution 
          is to foster a policy of transparency about social responsibility with the 
          entities that would use our probiotic. They would have to say clearly that 
          the cadmium contamination problem is not solved by using our probiotic, but 
          it is just a temporary solution waiting for decontamination and reduced exposure.
        </p>
        <p className="mb-2">
          A strong point for our product is its modularity, that allows it to be
          applied for the prevention of the intoxication by different compounds
          absorbed in the intestine. Nevertheless, as for cadmium, not in any
          way we want this solution to be used as a mean to avoid reducing
          environmental impact. To make sure that the product is properly used
          in the future and better control the buyers Michka Mélo warned us that
          a start-up incorporated as a traditional for-profit private company in
          the future would be risky and would induce a high risk of losing a
          certain level of control on the ethics of the company: the other
          shareholders might want to orient the company with more sales and more
          profit rather than careful ethical selection of customers, losing the
          control in this direction. However, if we choose a different financing
          and governance model, such as cooperative companies or foundations, we
          can have a high level of control on who we decide to work with, why
          and how. Lobbying for environmental protection and new processes
          against pollution. The topic of how to produce our solution without
          falling into greenwashing has strongly interested us.
        </p>

        <h2 id="integrated" className="mt-20">
          Integrated Human Practices
        </h2>
        <hr class="dividergeneral mb-5" />
        <p className="mb-2">
        Our first interest when we approached our project was to be sure of 
        its utility and assess with precision the issue we were tackling. 
        Our first conversation with Professor Murray McBride provided us 
        insights into the complex issue of cadmium contamination, its 
        effects on plants and the food chain, and potential strategies for 
        mitigation. It also confirmed that the remediation is still not sufficient 
        to protect the communities and the utility of our LBP.
        </p>
        <p className="mb-2">
          For the precise design of experiments to test our solution we reached
          out to experts at EPFL. This was particularly useful for how we
          approached the experiments concerning mucus binding.
        </p>
        <p className="mb-2">
          Discussing with industry representatives and our sustainability coach
          at EPFL brought attention to the potential of the modularity of our
          binding system. The possibility of applying it to different
          contaminants was of great interest. Nevertheless, it also
          underlined the necessity of having an open and transparent
          communication with the communities for the product to be successful.
        </p>
        <p className="mb-2">
          The most challenging part remained the medical one.
          The microbiota is a very delicate environment and the regulatory landscape of live
          biotherapeutic products (LBP) in Europe and worldwide is very complex.
        </p>
        <p className="mb-2">
        One of the biggest issues was not to disturb excessively the gut microbiota, 
        avoid colonisation of the gut and exchange of genetic material between our 
        bacteria and the microbiota. For this reason, our bacteria are expected to be 
        in the body for  48h and a particular attention was given in our experiments to 
        horizontal gene transfer.
        </p>
        <p className="mb-2">
          Lastly, we thought about how to implement our product and how to
          organise the team after iGEM. As already said in the sustainability
          section, we decided that 48C should be in a model such as cooperative
          companies or foundations, to have better control on its applications.
        </p>
        <p className="mb-2">
        For more specific information about the conversations we had and 
        how they influenced our project please refer to the interview section just below.
        </p>

        <h3 id="interviews" className="mt-20 mb-5">
          Interviews
        </h3>
        <p>
          Below you can see all the interviews that we conducted during our
          project. You can click on the images to get a preview of the interview
          of click on the read more button to get a more complete summary and
          description on how each meeting shaped our project. The interviews are
          divided in three sectors: academia, health care professionals and
          industry.
        </p>
      </div>
    </div>
  );
};

export default Article;
